import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';
import Select from './components/Select.vue';

export const Vozidlo = {
	name: NAME,
	apiProvider,
	router,
	components: {
		Select,
	},
};
